import { CrmIntegrationsResponse } from '../../types/CrmIntegrationsResponse';
import { GetOneFromPath, PostFormData, PostWithVoidReturn } from '../api/GenericClient';

async function getThoughtIndustriesJwt(
  dealerId: string,
  dealerName: string,
  jobTitle: string,
): Promise<any> {
  const apiPath = `/common/thoughtindustries?dealerId=${dealerId}&dealerName=${dealerName}&jobTitle=${jobTitle}`;
  return await GetOneFromPath<any>(apiPath);
}

async function postSupportRequest(request: any): Promise<any> {
  const url = `/common/supportrequest`;
  return await PostFormData(url, request);
}

async function postRevokeCarFaxAuth(clientId: string, existingRefreshToken: string): Promise<any> {
  const url = `/common/carFaxAccessTokenRevoke?clientId=${clientId}&accessToken=${existingRefreshToken}`;
  return await PostWithVoidReturn(url, {});
}

async function getCrmIntegrations(): Promise<CrmIntegrationsResponse> {
  const url = `/crm/crmintegration`;
  return await GetOneFromPath<CrmIntegrationsResponse>(url);
}

export const HeaderService = {
  getThoughtIndustriesJwt,
  postSupportRequest,
  postRevokeCarFaxAuth,
  getCrmIntegrations,
};
